import {menus} from '../../config/menus'

export default async function getMenuData() {
  return menus
}
